export default __webpack_public_path__ + "static/media/trustee2.bdc730fa.png";